import _ from 'lodash';

export default class FakeCustomer {
  constructor(data) {
    // It's a good practice to use lodash getters
    this.username = _.get(data, 'username');
    this.email = _.get(data, 'email');
  }

  get displayNameAndEmail() {
    return `Example fakeCustomer getter ${this.username} - ${this.email}`;
  }
}
